'use strict';

const scrollAnimate = require('base/components/scrollAnimate');
const { CLASSES } = require('../utils/globals');

const SELECTORS = {
    scrollTopButton: '.js-scroll-top-btn',
};

/**
 * Show or hide scroll button on document scroll
 * @returns {void}
 */
const handlePageScroll = () => {
    let scroll = $(window).scrollTop();
    $(SELECTORS.scrollTopButton)[scroll > 400 ? 'removeClass' : 'addClass'](CLASSES.hide);
}

/**
 * Scroll to top on button click
 * @returns {void}
 */
const handleButtonClick = (e) => {
    e.preventDefault();
    scrollAnimate();
}

const initEvents = () => {
    $(document).on('scroll', handlePageScroll);
    $(document).on('click', SELECTORS.scrollTopButton, handleButtonClick);
};

module.exports = () => {
    initEvents();
};
